/*
  ALMAM - sagetile de rasfoire de pe fotografia mare a paginii de produs.

  Ce fac: trec la fotografia dinainte / de dupa. Inainte, singurele sageti ale
  galeriei stateau pe banda de miniaturi si o DERULAU, ceea ce nu e ce asteapta
  cineva de la o sageata pusa peste imagine.

  Cum o fac: apasa butonul miniaturii vecine. `media-gallery.js` leaga deja
  fiecare miniatura de `setActiveMedia`, deci trecand pe acolo nu exista o a
  doua definitie a ceea ce inseamna "imaginea activa" - iar starea miniaturilor,
  atributul `aria-current` si aducerea benzii pe miniatura activa
  (`almam-product-thumbs.js`) vin toate pe gratis.

  De ce butoane proprii, fara `name`: `SliderComponent` al temei isi leaga
  butoanele dupa `name="previous"` / `name="next"` si le calculeaza starea de
  dezactivat din pozitia de derulare ORIZONTALA a listei. Pe ecran lat lista nu
  se deruleaza deloc, deci tema le-ar dezactiva pe amandoua.

  Se numara MINIATURILE VIZIBILE, nu elementele din lista de media: cand tema e
  pusa sa ascunda imaginile de varianta, cele doua liste nu mai au acelasi
  numar de elemente, iar pasul ar sari peste o fotografie sau ar duce la una
  ascunsa.
*/

(function () {
  'use strict';

  function thumbButtons(gallery) {
    var list = gallery.querySelector('.thumbnail-list');
    if (!list) return [];

    return Array.prototype.filter.call(
      list.querySelectorAll('.thumbnail-list__item button'),
      function (button) {
        /* `offsetParent` e null si cand elementul e ascuns de un parinte, deci
           prinde si miniaturile scoase din joc de clasele `small-hide` ale
           temei, nu doar pe cele ascunse direct. */
        return button.offsetParent !== null;
      }
    );
  }

  function currentIndex(buttons) {
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function connect(gallery) {
    var prev = gallery.querySelector('[data-almam-media="prev"]');
    var next = gallery.querySelector('[data-almam-media="next"]');
    if (!prev || !next) return;

    function refresh() {
      var buttons = thumbButtons(gallery);

      /* Ascunse cu totul cand nu au ce rasfoi: un buton mort in pagina e zgomot,
         inclusiv pentru cititoarele de ecran. */
      var nothingToBrowse = buttons.length < 2;
      prev.hidden = nothingToBrowse;
      next.hidden = nothingToBrowse;
      if (nothingToBrowse) return;

      /* Galeria NU se invarte in bucla: are un inceput si un sfarsit, iar
         sageata dinspre capatul atins se stinge. Starea NU se marcheaza cu
         atributul `disabled`, fiindca tema are o regula care ascunde complet
         butoanele dezactivate - starea nu ar mai fi fost a mea. */
      var i = currentIndex(buttons);
      var atStart = i === 0;
      var atEnd = i === buttons.length - 1;

      prev.classList.toggle('almam-media-nav--end', atStart);
      next.classList.toggle('almam-media-nav--end', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function step(direction) {
      return function () {
        var buttons = thumbButtons(gallery);
        if (buttons.length < 2) return;

        var target = currentIndex(buttons) + direction;
        if (target < 0 || target > buttons.length - 1) return;

        buttons[target].click();
      };
    }

    prev.addEventListener('click', step(-1));
    next.addEventListener('click', step(1));

    /* Fotografia activa se poate schimba si fara sagetile astea - din miniaturi,
       din glisare pe telefon, sau la alegerea unei variante - deci starea se
       reciteste din `aria-current`, sursa pe care o scrie tema, nu dintr-un
       contor propriu care ar putea ramane in urma. */
    var list = gallery.querySelector('.thumbnail-list');
    if (list) {
      new MutationObserver(refresh).observe(list, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-current']
      });
    }

    /* Numarul de miniaturi VIZIBILE se schimba la trecerea pragurilor temei. */
    window.addEventListener('resize', refresh);

    refresh();
  }

  /* Aceeasi galerie nu se leaga de doua ori: in editorul de teme evenimentul de
     reincarcare poate ajunge si pentru sectiuni care nu au fost re-randate. */
  var LEGAT = 'almamMediaNavLegat';

  function init(radacina) {
    (radacina || document).querySelectorAll('.product--almam media-gallery').forEach(function (gallery) {
      if (gallery.dataset[LEGAT]) return;
      gallery.dataset[LEGAT] = '1';
      connect(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
